import { NgModule } from '@angular/core';

import { TableCellSortableHeaderComponent } from './components/table-cell-sortable-header';
import { TableCellFooterDirective } from './directives/table-cell-footer.directive';
import { TableCellHeaderDirective } from './directives/table-cell-header.directive';
import { TableCellDirective } from './directives/table-cell.directive';
import { TableComponent } from './table.component';

@NgModule({
  imports: [TableComponent, TableCellHeaderDirective, TableCellDirective, TableCellFooterDirective, TableCellSortableHeaderComponent],
  exports: [TableComponent, TableCellHeaderDirective, TableCellDirective, TableCellFooterDirective, TableCellSortableHeaderComponent],
})
export class TableModule {}
